import { useCurrentUserContext } from '@/contexts';
import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import { AuthorNotice } from '@/pages/Schedule/components/AuthorNotice';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { useVisitorContext } from '@/pages/Schedule/contexts/VisitorContext/useVisitorContext';
import { useSchedulePermissions } from '@/pages/Schedule/hooks';
import { Flex, Text } from '@/ui';
import { AddToCalendarModal } from '../../../AddToCalendarModal';
import { ShareModal } from '../../../ShareModal';
import { useToolbarButtons } from '../../hooks/useToolbarButtons';
import { Header } from '../Header';
import { SharedUsersStack } from './SharedUsersStack';

export const PrivateHeader = () => {
  const { isPublicRole } = useScheduleContext();
  const { hasSchedulePermission } = useSchedulePermissions();
  const { isAuthenticated } = useCurrentUserContext();
  const isMobileBreakpoint = useIsMobileBreakpoint();
  const toolbarButtons = useToolbarButtons();
  const { isCollaboratorView } = useVisitorContext();

  const showAddToCalendarButton =
    !isMobileBreakpoint && hasSchedulePermission('SCHEDULE_EXPORT');

  const showShareButton =
    !isMobileBreakpoint && hasSchedulePermission('PERMISSIONS_MODIFY');

  const isEditor = hasSchedulePermission('ENTRY_CREATE');

  return (
    <Header
      hideProfileMenu={!isMobileBreakpoint && !isAuthenticated}
      middleColumn={isEditor && !isCollaboratorView ? <AuthorNotice /> : null}
      sx={{ '@media print': { display: 'none' } }}
      leftColumn={
        isMobileBreakpoint ? (
          <Text
            color="dark.500"
            fontSize="17px"
            fontWeight="extrabold"
            lineHeight="normal"
          >
            agendahero
          </Text>
        ) : (
          toolbarButtons
        )
      }
      rightColumn={
        isAuthenticated && (
          <Flex align="center" gap="3">
            {!isPublicRole && !isMobileBreakpoint && <SharedUsersStack />}
            {isMobileBreakpoint && toolbarButtons}
            {showAddToCalendarButton && <AddToCalendarModal />}
            {showShareButton && <ShareModal />}
          </Flex>
        )
      }
    />
  );
};
